import gql from 'graphql-tag';

export const ISSUES_TIMESTAMPS_BY_METRIC_QUERY = gql`
  query IssuesTimestampsByMetricQuery(
    $entityName: String!
    $projectName: String!
    $runName: String!
    $bucketedHistorySpecs: [JSONString!]!
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
      }
    }
  }
`;
